exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.success {\n    color: #67C23A;\n    font-size: 22px;\n}\n.danger {\n    color: #F56C6C;\n    font-size: 22px;\n}\n.formTable {\n    width: 100%;\n    margin-top: 5px;\n    border-collapse: collapse;\n    border: 1px solid #888;\n}\n.formTable th, \n.formTable td {\n    border: 1px solid #888;\n}\n.list{\n    padding-left: 14px;\n}\n", ""]);

// exports
